var render, staticRenderFns
import script from "./ticketDetail copy.vue?vue&type=script&lang=js"
export * from "./ticketDetail copy.vue?vue&type=script&lang=js"
import style0 from "./ticketDetail copy.vue?vue&type=style&index=0&id=7c9a4e78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9a4e78",
  null
  
)

export default component.exports